import { JOB_SLUG_LENGTH } from "@workspace/dto/job/constants";

export function buildListingSlug(
  slug: string,
  title: string,
  orgName: string
): string {
  const titleSlug = `${title}-at-${orgName}`
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)/g, "");
  return `${slug}-${titleSlug}`;
}

export function buildListingUrl(
  slug: string,
  title: string,
  orgName: string
): string {
  return `/job-listings/${buildListingSlug(slug, title, orgName)}`;
}

export function extractNanoId(fullSlug: string): string {
  return fullSlug.slice(0, JOB_SLUG_LENGTH);
}
